<template id="base-pagination-page">
  <li class="base-pagination-trigger" @click="loadPage">
    <a href="#top-list">{{ pageNumber }}</a>
  </li>
</template>

<script>
export default{
    name:"PaginationPage",
    components: {

    },
    emits: ['load-page'],
    props: {
      pageNumber: {
        type: Number,
        required: true
      }
    },
    data(){
      return{

      }
    }, 
    methods:{
      loadPage() {
        this.$emit("load-page", this.pageNumber)
      }
    },
    computed: {

    }
}
</script>